import { SessionEpics } from './session/session.epics';
import { XprtDataEpics } from './xprt-data/xprt-data.epics';
import { ToolsEpics } from './tools';
import { ApiEpics } from './api-epics';
import { UiEpics } from './ui-epics';
import { EventsEpics } from './events';

export * from './session/session.epics';
export * from './xprt-data/xprt-data.epics';
export * from './tools';
export * from './api-epics';
export * from './ui-epics';
export * from './events';

export const EPIC_PROVIDERS: any[] = [
  ApiEpics,
  UiEpics,
  SessionEpics,
  XprtDataEpics,
  ToolsEpics,
  EventsEpics,
];
